import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";
import { RenewalChip } from "@/components/Primitives";

function daysUntil(iso) { if (!iso) return 0; return Math.round((new Date(iso) - new Date())/(1000*60*60*24)); }

export default function Licenses() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/licenses").then(r => setItems(asArray(r.data))); }, []);
  return (
    <div className="space-y-4">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">License Governance</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Licenses ({items.length})</h1>
      </div>
      <div className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 text-[10px] uppercase tracking-widest text-zinc-500 font-mono"><tr><th className="text-left px-4 py-3">Product</th><th className="text-left px-4 py-3">Vendor</th><th className="text-left px-4 py-3">Seats</th><th className="text-left px-4 py-3">Utilization</th><th className="text-left px-4 py-3">Annual Cost</th><th className="text-left px-4 py-3">Expires</th></tr></thead>
          <tbody>
            {items.map(l => (
              <tr key={l.id} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="px-4 py-2">{l.product}</td>
                <td className="px-4 py-2 text-zinc-400">{l.vendor}</td>
                <td className="px-4 py-2 font-mono">{l.seats_used}/{l.seats_total}</td>
                <td className="px-4 py-2">
                  <div className="w-32 bg-zinc-900 rounded-full h-1.5"><div className="h-1.5 bg-blue-500 rounded-full" style={{width:`${l.utilization_pct}%`}}/></div>
                  <div className="text-[10px] font-mono text-zinc-500 mt-0.5">{l.utilization_pct}%</div>
                </td>
                <td className="px-4 py-2 font-mono text-emerald-400">${l.annual_cost_usd?.toLocaleString()}</td>
                <td className="px-4 py-2"><RenewalChip daysLeft={daysUntil(l.expires_at)}/></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
